import { useState, type FC, type PropsWithChildren } from 'react';
import CountrySelect from 'components/CountrySelect';
import countries from 'assets/data/countries';
import { COUNTRY_RESTRICTIONS } from 'assets/countries';
import { AccentText } from 'components/Gen.2/Typography';
import {
  Coverage,
  Heading,
  Container,
  SelectContainer,
  CoverageBox,
  Placeholder
} from './styled';
import CountryCoverageDetails from './components/CountryCoverageDetails';

type CoverageCountry = (typeof countries)[number];

type CountryCoverageProps = PropsWithChildren<{
  variant?: 'light' | 'dark';
  className?: string;
}>;

const CountryCoverage: FC<CountryCoverageProps> = ({ variant = 'dark', ...props }) => {
  const [coverageCountry, setCoverageCountry] = useState<CoverageCountry | null>(null);

  return (
    <Coverage {...props}>
      <Heading>
        Cover everyone in 175+ countries{' '}
        <AccentText colorName="bermudaGreen">under one plan</AccentText>
      </Heading>
      <Container>
        <SelectContainer>
          <CountrySelect
            countries={countries}
            selectedCountry={coverageCountry}
            onSelect={setCoverageCountry}
          />
        </SelectContainer>
        <CoverageBox variant={variant}>
          {coverageCountry ? (
            <CountryCoverageDetails
              coverageCountry={coverageCountry}
              travelOnly={COUNTRY_RESTRICTIONS.TRAVEL_ONLY_COUNTRIES.includes(
                coverageCountry.code
              )}
              addOn={COUNTRY_RESTRICTIONS.ADDON_COUNTRIES.includes(coverageCountry.code)}
              sanctioned={COUNTRY_RESTRICTIONS.SANCTIONED_COUNTRIES.includes(
                coverageCountry.code
              )}
            />
          ) : (
            <Placeholder>Select a country to see coverage</Placeholder>
          )}
        </CoverageBox>
      </Container>

      {/* List all countries for debugging reasons */}
      {/* {countries.map((country) => (
        <CoverageBox key={country.code} variant={variant}>
          <CountryCoverageDetails
            coverageCountry={country}
            travelOnly={COUNTRY_RESTRICTIONS.TRAVEL_ONLY_COUNTRIES.includes(country.code)}
            addOn={COUNTRY_RESTRICTIONS.ADDON_COUNTRIES.includes(country.code)}
            sanctioned={COUNTRY_RESTRICTIONS.SANCTIONED_COUNTRIES.includes(country.code)}
          />
        </CoverageBox>
      ))} */}
    </Coverage>
  );
};

export default CountryCoverage;
